import React from 'react';
import SEO from '../components/common/SEO';
import Hero from '../components/home/Hero';
import FeaturedProjects from '../components/home/FeaturedProjects';
import TestimonialsCarousel from '../components/home/TestimonialsCarousel';

const Home = () => {
  return (
    <>
      <SEO
        title="Ky Tracy - Professional Photography & Creative Services"
        description="Professional portrait photography, writing, and social media services by Ky Tracy. Capturing empowering and authentic portraits that reveal your unique essence."
        url="/"
      />
      <div>
        <Hero />
        <FeaturedProjects />
        <TestimonialsCarousel />
      </div>
    </>
  );
};

export default Home;
